export const MAX_FILE_SIZE = 5242880;
// order is important
export const SUPPORTED_IMAGE_TYPES = ['image/svg+xml', 'image/jpg', 'image/jpeg', 'image/png', 'image/gif'];
export const SUPPORTED_CSV_TYPES = ['.csv', 'text/csv'];
export const SUPPORTED_ZIP_TYPES = ['zip', 'application/zip', 'application/zip-compressed', 'application/x-zip-compressed', 'multipart/x-zip'];
export const SUPPORTED_HTML_TYPES = ['text/html'];
export const SUPPORTED_JSON_TYPES = ['application/json'];
export const SUPPORTED_AUDIO_TYPES = [
  'audio/mpeg', 'audio/mp3', 'audio/wav', 'audio/x-wav', 'audio/mp4', 'video/mp4',
  'audio/webm', 'audio/ogg', 'audio/flac', 'audio/x-flac', 'audio/aac'
];
export const MAX_AUDIO_DURATION_SECONDS = 10;
export const AUDIO_FILE_INPUT_ACCEPT = [
  ...SUPPORTED_AUDIO_TYPES, '.mp3', '.wav', '.m4a', '.mp4', '.webm', '.ogg', '.flac', '.aac'
];

export const APPLICATION_OCTET_STREAM = 'application/octet-stream';

const EXCEL_TYPES = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
const WORD_TYPES = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
const POWER_POINT_TYPES = ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'];
const TEXT_TYPES = ['text/plain'];
const PDF_TYPES = ['application/pdf'];
const ICS_TYPES = ['text/calendar'];
const MSG_TYPES = ['application/vnd.ms-outlook'];
const FONT_TYPES = ['.woff', '.woff2', '.ttf','.otf', '.eot',
'font/woff', 'font/woff2', 'font/ttf', 'font/otf', 'application/vnd.ms-fontobject', 'application/font-woff'];

export const SUPPORTED_REPORT_TYPES = [
  ...SUPPORTED_IMAGE_TYPES,
  ...SUPPORTED_CSV_TYPES,
  ...SUPPORTED_ZIP_TYPES,
  ...SUPPORTED_HTML_TYPES,
  ...EXCEL_TYPES,
  ...WORD_TYPES,
  ...POWER_POINT_TYPES,
  ...TEXT_TYPES,
  ...PDF_TYPES,
  ...MSG_TYPES,
  ...ICS_TYPES
];

export const SUPPORTED_ASSETS_IMAGE_TYPES = [
  ...SUPPORTED_IMAGE_TYPES,
  'image/tiff'
];

export const SUPPORTED_ASSETS_TYPES = [
  ...SUPPORTED_ASSETS_IMAGE_TYPES,
  ...SUPPORTED_ZIP_TYPES,
  ...PDF_TYPES,
  ...SUPPORTED_CSV_TYPES,
  ...TEXT_TYPES,
  ...EXCEL_TYPES,
  ...WORD_TYPES,
  ...POWER_POINT_TYPES,
  ...FONT_TYPES,
  ...SUPPORTED_HTML_TYPES,
  'doc', 'docx', 'ppt', 'pptx', 'audio/mp3', 'audio/mpeg', 'audio/wav',
  'video/mp4', 'video/mov', 'video/quicktime', 'xls', 'xlsx', 'txt', 'html'
];

export const SUPPORTED_REPORT_FILE_NAME_EXTENSIONS = ['ppt', 'pptx', 'doc', 'docx', 'xls', 'xlsx', 'ics', 'msg', 'zip'];

export const IMAGE_VALIDATION_FORMAT_ERROR_MESSAGE = 'File type is not valid, please upload a .png, .jpg, .gif or .svg';
export const IMAGE_VALIDATION_FORMAT_ERROR_MESSAGE_EXCEPT_SVG = 'File type is not valid, please upload a .png, .jpg or .gif';
export const IMAGE_VALIDATION_SIZE_ERROR_MESSAGE = 'File is too large, maximum file size is 5MB';
export const FILE_UPLOAD_UNSUPPORTED_TYPE_ERROR_MESSAGE = (fileName: string): string =>
  `${fileName} was not uploaded, its file type is not supported`;
export const AUDIO_VALIDATION_FORMAT_ERROR_MESSAGE = 'File type is not valid, please upload a .mp3, .wav, .m4a, .mp4, .webm, .ogg, .flac or .aac';
export const AUDIO_VALIDATION_SIZE_ERROR_MESSAGE = 'File is too large, maximum file size is 5MB';
export const AUDIO_VALIDATION_DURATION_ERROR_MESSAGE = `Audio is too long, maximum duration is ${MAX_AUDIO_DURATION_SECONDS} seconds`;
export const ASSETS_VALIDATION_FORMAT_ERROR_MESSAGE = `
  File type is not valid, please upload a .jpeg, .png, .tiff, .svg, .pdf, .doc, .docx,
  .ppt, .pptx, .mp3, .wav, .mp4, .mov, .gif, .csv, .xlsx, .xlsx, .txt, .zip, .html, .woff, .woff2, .ttf, .otf, .eot`;
export const DIMENSIONS_PROFILE_IMAGE = 100;